/**
 * @packageDocumentation
 * @module api.functional.auth.verify_email
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponsenull } from "../../../structures/ServiceResponsenull";

/**
 * @controller AuthController.validateEmailVerificationToken
 * @path GET /auth/verify-email
 * @accessor api.functional.auth.verify_email.validateEmailVerificationToken
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function validateEmailVerificationToken(
  connection: IConnection,
  token: string,
): Promise<validateEmailVerificationToken.Output> {
  return PlainFetcher.fetch(connection, {
    ...validateEmailVerificationToken.METADATA,
    template: validateEmailVerificationToken.METADATA.path,
    path: validateEmailVerificationToken.path(token),
  });
}
export namespace validateEmailVerificationToken {
  export type Output = ServiceResponsenull;

  export const METADATA = {
    method: "GET",
    path: "/auth/verify-email",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (token: string) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries({
      token: token,
    } as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/auth/verify-email";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
